import styled from 'styled-components';

export const StyledProgressWrapper = styled.div`
  .ant-progress-inner {
    background-color: transparent !important;
  }
`;
